import { BoundsScrollProps, ComputedBounds } from "../types";

interface CollideOptions {
    withOffsetSize: boolean;
}

/**
 * Calculates and returns provided element's boundaries relative to it's container.
 * @param node html element to get bounds for
 * @param containerScroll html element's container's scroll amounts
 * @returns object: {
 *      width: element's width
 *      height: element's height
 *      top: element's top position relative to it's container
 *      left: elemment's left position relative to it's container
 *      offsetWidth: element's offset width
 *      offsetHeight: element's offset height
 * }
 */
function getBoundsForNode(
    node: HTMLElement,
    containerScroll: BoundsScrollProps = { scrollTop: 0, scrollLeft: 0 }
): ComputedBounds {
    const { scrollTop, scrollLeft } = containerScroll;

    const { width: rectWidth, height: rectHeight, top: rectTop, left: rectLeft } = node.getBoundingClientRect();

    return {
        width: rectWidth,
        height: rectHeight,
        top: rectTop + scrollTop,
        left: rectLeft + scrollLeft,
        offsetWidth: node.offsetWidth,
        offsetHeight: node.offsetHeight
    };
}

/**
 * Checks if there are any intersection points between provided bounds.
 * @param a an element's computed bounds
 * @param b an element's computed bounds
 * @param options there is only one option, withOffsetSize. While check for a collision we will consider
 * bounds' width if this option is false. Otherwise, we will consider bound's offsetWidth
 * @returns boolean if two bounds collide or not
 */
function boundsCollide(a: ComputedBounds, b: ComputedBounds, { withOffsetSize }: CollideOptions): boolean {
    const aWidth = withOffsetSize ? a.offsetWidth : a.width;
    const aHeight = withOffsetSize ? a.offsetHeight : a.height;
    const bWidth = withOffsetSize ? b.offsetWidth : b.width;
    const bHeight = withOffsetSize ? b.offsetHeight : b.height;

    return !(
        a.top + aHeight < b.top ||
        a.top > b.top + bHeight ||
        a.left + aWidth < b.left ||
        a.left > b.left + bWidth
    );
}

export {
    BoundsScrollProps,
    ComputedBounds,
    getBoundsForNode,
    boundsCollide
};
